import React from 'react';

// Packages
import { Field, FieldArray } from 'redux-form';
import Pluralize from 'pluralize'

// Helpers
import { capitalizeString } from '../../../../utils/helpers';
import { required } from '../../../../utils/formValidators'

// Form Components
import ReduxFormInput from '../../../../components/Global/ReduxForms/ReduxFormInput'
import ReduxSplitInputContainer from '../../../../components/Global/ReduxForms/ReduxSplitInputContainer'
import ReduxMaskedFormInput from '../../../../components/Global/ReduxForms/ReduxMaskedFormInput'

const ContactFormCategory = ({ category }) => (
  <div className="contact-form-category">
    <h2>{capitalizeString(category)}</h2>
    <FieldArray
      name={`contacts.${category}`}
      component={renderContacts}
      props={{type: Pluralize.singular(category)}}
    />
    <hr/>
  </div>
)

const renderContacts = ({ fields, type }) => (
  <ul>
    {
      fields.map((contact, index) => (
        <li key={index}>
          <ReduxSplitInputContainer>
            <Field
              name={`${contact}.name`}
              type="text"
              component={ReduxFormInput}
              label="Name"
              validate={required}
              handleInputRemoval={() => fields.remove(index)}
            />

            <Field
              name={`${contact}.relationship`}
              type="text"
              component={ReduxFormInput}
              label="Relationship"
              validate={required}
            />

            <Field
              name={`${contact}.email`}
              type="text"
              component={ReduxFormInput}
              label="Email"
              validate={required}
            />

            <Field
              name={`${contact}.phone`}
              type="tel"
              component={ReduxMaskedFormInput}
              label="Phone"
              mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              validate={required}
              placeholder="(555) 555-5555"
              placeholderChar={'\u2000'}
              guide={true}
            />
          </ReduxSplitInputContainer>
        </li>
      ))
    }
    <li>
      <button type="button" onClick={() => fields.push({})}>
        {`+ Add a ${capitalizeString(type)}`}
      </button>
    </li>
  </ul>
)

export default ContactFormCategory



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/Contact/ContactFormCategory.js